<template>
    <v-container fluid>
      <!-- some comments updated -->
      <v-card>
        <v-toolbar color="secondary" flat dense>
          <v-toolbar-title>Accounts</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <v-row class="mt-2">
            <v-btn color="primary" small to="/new-account">
              <v-icon left dark>mdi-plus</v-icon>New Account
            </v-btn>
          </v-row>
  
          <v-row>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-row>
  
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <!-- start of table -->
              <v-data-table
                :items-per-page="200"
                :mobile-breakpoint="zeroValue"
                :headers="headers"
                :items="accounts"
                :search="search"
              >
                <!-- type template -->
                <template v-slot:item.Type="{ item }">
                  <span v-if="item.Type == 'C'">Cash</span>
                  <span v-if="item.Type == 'M'">Mpesa</span>
                  <span v-if="item.Type == 'B'">Bank</span>
                  <span v-if="item.Type == 'Q'">Cheque</span>
                  <span v-if="item.Type == 'F'">Float</span>
                </template>
                <!-- end of type template -->
  
                <!-- category template -->
                <template v-slot:item.category="{ item }">
                  <span v-if="item.category">{{item.category.Name}}</span>
                </template>
                <!-- end -->
  
                <!-- action template -->
                <template v-slot:item.action="{ item }">
                  <v-btn color="editIcon" text :to="`/account/${item.id}`" icon>
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <!-- end -->
              </v-data-table>
              <!-- end -->
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
  
      <snackbar ref="snackbar"></snackbar>
    </v-container>
  </template>
  
  <script>
  export default {
    data: () => ({
      search: "",
      zeroValue: 0,
      headers: [
        { text: "Account Name", value: "Name" },
        // { text: "Account Type", value: "Type" },
        { text: "Category", value: "AccountCategory.Name" },
        { text: "Owner", value: "owner.name" },
        // { text: "Balance", value: "Balance" },
        { text: "Action", value: "action" }
      ],
      accounts: []
    }),
    methods: {
      getAccounts() {
        const self = this;
        this.$store
          .dispatch("get", `/accounts`)
          .then(res => {
            if (res.ResultCode == 1200) {
              self.accounts = res.ResponseData;
            } else {
              this.$refs.snackbar.show(res.msg, "red");
            }
          })
          .catch(err => {
            this.$refs.snackbar.show(err, "red");
          });
      }
    },
    created() {
      this.getAccounts();
    }
  };
  </script>